import { useField, useFormikContext } from 'formik'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { BlogPostLength } from 'components/Wizards/BlogPostWizard/Types'
import { FormButton } from '../FormButton/FormButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

export const BlogLengthSelect = () => {
  const { status } = useFormikContext()
  const [field, , { setValue }] = useField('blog_length')
  const { isMobile } = useResponsiveDesign()

  if (status === FormStatus.AutoFilling) {
    return <TextFieldLoadingState fixedWidth={250} />
  }

  return (
    <Select
      size="lg"
      variant='secondary'
      selectedKey={field.value}
      onSelectionChange={(key) => {
        setValue(key as string)
      }}
      aria-label="Select blog post length"
      ButtonComponent={isMobile ? FormButton : undefined}
    >
      <Item key={BlogPostLength.Short}>Short (400-600 words)</Item>
      <Item key={BlogPostLength.Medium}>Medium (600-1000 words)</Item>
      <Item key={BlogPostLength.Long}>Long (1000+ words)</Item>
    </Select>
  )
}
